import { request } from './request'

// 用户通过code登录接口
export function getUserInfo (params) {
  return request({
    url: 'user/getUserInfo',
    method: 'POST',
    data: params
  })
}

// 获取选手列表
export function requestUserList (params) {
  return request({
    url: 'user/index',
    method: 'GET',
    params
  })
}
// 获取选手详情
export function requestUserDetail (params) {
  return request({
    url: 'user/player',
    method: 'GET',
    params
  })
}
// 用户投票
export function toVote (params) {
  return request({
    url: 'match/enjoyArticle',
    method: 'POST',
    data: params
  })
}
// 活动详情介绍
export function getActivityDetail (params) {
  return request({
    url: 'activity/detail',
    method: 'GET',
    data: params
  })
}
// 首页轮播滚动
export function getActivityIndex (params) {
  return request({
    url: 'activity/index',
    method: 'POST',
    data: params
  })
}